import EpiApiClient from "@/services/serviceClients/epiApiClient";
import {
    GETLEADS_API_PATH,
    PRO_REFERRAL_LEADS_API_PATH,
    PRO_REFERRAL_LEAD_ADDRESS_API_PATH
} from "@/config/constants";


class LeadService {
  static async getLeads(searchTerm = "", skip = 0, take = 50, sortBy = null, sortDir = null, cancelToken = null) {
    try {
      const params = {
        searchTerm,
        skip,
        take,
      };

      if (sortBy) {
        params.sortBy = sortBy;
      }
      if (sortDir) {
        params.sortDir = sortDir;
      }

      const config = {
        params,
      };

      if (cancelToken) {
        config.cancelToken = cancelToken;
      }

      const response = await EpiApiClient.get(GETLEADS_API_PATH, config);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (error.__CANCEL__) {
        throw error;
      }

      const errorMessage = error.response
        ? error.response.data.error_description || error.response.data
        : error.message || "request failed";
      return {
        success: false,
        error: errorMessage,
      };
    }
  }

  static async getLeadById(leadId) {
      try {
      const url = `${GETLEADS_API_PATH}/${leadId}`;
      const response = await EpiApiClient.get(url);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.error_description || error.response.data
        : error.message || "request failed";
      return {
        success: false,
        error: errorMessage,
      };
    }
  }

  static async updateUserState(leadId, { customName = null, dismissed = null } = {}) {
    try {
      const params = {};
      if (customName !== null) {
        params.customName = customName;
      }
      if (dismissed !== null) {
        params.dismissed = dismissed;
        }


      const url = `${GETLEADS_API_PATH}/${leadId}/user-state`;
      const response = await EpiApiClient.put(url, null, {
        params
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.error_description || error.response.data
        : error.message || "request failed";
      return {
        success: false,
        error: errorMessage,
      };
    }
  }

  static async getProReferrals({ searchTerm = "", leadStatus = "", pageNumber = 1, pageSize = 10 } = {}) {
    try {
      const response = await EpiApiClient.get(PRO_REFERRAL_LEADS_API_PATH, {
        params: { searchTerm, leadStatus, pageNumber, pageSize },
      });
      return {
        success: true,
        data: response.data,
        error: null,
      };
    } catch (error) {
      const errorMessage = error.response?.data?.error_description
        || error.message
        || "request failed";
      console.error("LeadService.getProReferrals failed:", errorMessage, error);
      return {
        success: false,
        data: null,
        error: errorMessage,
      };
    }
  }

  static async updateProReferralLeadAddress({ leadId, address, isPickupAtBranch = false, branchCode = null } = {}) {
    try {
      const response = await EpiApiClient.put(PRO_REFERRAL_LEAD_ADDRESS_API_PATH, {
        LeadID: leadId,
        Address: address,
        IsPickupAtBranch: isPickupAtBranch,
        BranchCode: branchCode,
      });
      return {
        success: true,
        data: response.data,
        error: null,
      };
    } catch (error) {
      const errorMessage = error.response?.data?.error_description
        || error.message
        || "request failed";
      console.error("LeadService.updateProReferralLeadAddress failed:", errorMessage, error);
      return {
        success: false,
        data: null,
        error: errorMessage,
      };
    }
  }
}

export default LeadService;
